import { Component, Input, OnInit } from '@angular/core';
import { ObservationAction } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-observation-action',
  templateUrl: './observation-action.component.html',
  styleUrls: ['./observation-action.component.css']
})
export class ObservationActionComponent implements OnInit {

  @Input() ObservationActionData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedObs: { [s: string]: ObservationAction } = {};
  ObsActData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {

  }


  onRowEditInit(Obs: ObservationAction) {
    this.clonedObs[Obs.Id] = { ...Obs };
    this.DisableExport = true;
  }

  onRowEditSave(Obs: ObservationAction, index: number) {
    if (Obs.Id > 0) {

      if (this.clonedObs[Obs.Id].WithAction != Obs.WithAction) {
        this.ObservationActionData[this.ObservationActionData.length - 1].WithAction = this.ObservationActionData[this.ObservationActionData.length - 1].WithAction - this.clonedObs[Obs.Id].WithAction + Obs.WithAction;
      }
      if (this.clonedObs[Obs.Id].WithoutAction != Obs.WithoutAction) {
        this.ObservationActionData[this.ObservationActionData.length - 1].WithoutAction = this.ObservationActionData[this.ObservationActionData.length - 1].WithoutAction - this.clonedObs[Obs.Id].WithoutAction + Obs.WithoutAction;
      }
      delete this.clonedObs[Obs.Id];
    }
    this.DisableExport = Object.keys(this.clonedObs).length > 0 ? true : false;
  }

  onRowEditCancel(Obs: ObservationAction, index: number) {
    this.ObservationActionData[index] = this.clonedObs[Obs.Id];
    delete this.clonedObs[Obs.Id];
    this.DisableExport = Object.keys(this.clonedObs).length > 0 ? true : false;
  }

  GetObservationActionSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Observation Action",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetObservationActionSelectedDetails.bind(this));
  }
  callbackMethodForGetObservationActionSelectedDetails(response){
    if(response.Success)
    this.ObsActData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/observation/make-observation/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+value+';unitId='+UnitId], '_self');
  }

   //BOC Pritesh
   exportToExcel()
   {
 
   let element = document.getElementById('ObservationActionTableToExport');
   const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
   ws['!ref'] = ws['!ref'].replace('D','C');//to remove Actions Column
   /* generate workbook and add the worksheet */
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
   /* save to file */  
   XLSX.writeFile(wb, "ObservationAction.xlsx");
 
   }
   //EOC Pritesh

}
